import axios from "axios";
import { getAuth } from "./auth";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

// Attach role + token headers on every request if logged in
api.interceptors.request.use((config) => {
  const auth = getAuth();
  if (auth) {
    config.headers["x-teller-role"] = auth.role;
    config.headers["x-teller-token"] = auth.token;
  }
  return config;
});
